import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../../../components/Header";
import { BackArrow } from "../../../../Icons/BackArrow";
import ImageSlider from "./ImagesSlider";
import { useGetData } from "../../../../Network/useGetQueryData";

const results = [
  "https://medhub-development.s3.amazonaws.com/images/d611cf5a-bf00-49b1-8e60-8b6b0b62a6e3.jpeg",
  "https://medhub-development.s3.amazonaws.com/images/4a29a593-09ed-4cc8-8fcb-6be3b55877eb.jpeg",
  "https://medhub-development.s3.amazonaws.com/images/c6f43fd1-62fa-4298-8ddf-a54329bd6b8e.jpeg",
];

export const ViewResult = () => {
  const { requestId } = useParams();
  const navigate = useNavigate();

  const { data: resultsList } = useGetData<{
    data: any;
  }>({
    queryKey: ["service-request-visit"],
    url: `service-request-visit-result?serviceRequestId=${requestId}&offset=0&limit=10&withDeleted=false`,
    options: {
      enabled: !!requestId,
      queryKey: ["service-request-visit"],
    },
  });

  if (!resultsList) return;

  const results = resultsList?.data?.items?.filter(
    (i) => i.serviceRequestId === +requestId
  )?.[0]?.resultsUrls;

  return (
    <div className="view-request-results">
      <Header
        title="View Result"
        backIcon={
          <span
            style={{ cursor: "pointer" }}
            onClick={() => navigate(`/request/${requestId}`)}
          >
            <BackArrow />
          </span>
        }
      />

      <ImageSlider resultsUrls={results || []} />
    </div>
  );
};
